import React from "react";

interface UploadButtonProps {
  onClick: () => void;
}

const UploadButton: React.FC<UploadButtonProps> = ({ onClick }) => {
  return (
    <button onClick={onClick} className="bg-gray-300 text-black py-2 px-4 rounded-md hover:bg-gray-500 focus:outline-none">
      Upload File
    </button>
  );
};

export default UploadButton;
